/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-northeast-1",
    "aws_cloud_logic_custom": [
        {
            "name": "dashboard",
            "endpoint": "https://l3u2ef673c.execute-api.ap-northeast-1.amazonaws.com/staging",
            "region": "ap-northeast-1"
        },
        {
            "name": "form",
            "endpoint": "https://qchmfig67i.execute-api.ap-northeast-1.amazonaws.com/staging",
            "region": "ap-northeast-1"
        },
        {
            "name": "getUser",
            "endpoint": "https://730k75hau9.execute-api.ap-northeast-1.amazonaws.com/staging",
            "region": "ap-northeast-1"
        },
        {
            "name": "invite",
            "endpoint": "https://jhruzau2li.execute-api.ap-northeast-1.amazonaws.com/staging",
            "region": "ap-northeast-1"
        },
        {
            "name": "link",
            "endpoint": "https://sz4hxw7oxj.execute-api.ap-northeast-1.amazonaws.com/staging",
            "region": "ap-northeast-1"
        },
        {
            "name": "login",
            "endpoint": "https://gifejb6fb9.execute-api.ap-northeast-1.amazonaws.com/staging",
            "region": "ap-northeast-1"
        },
        {
            "name": "mail",
            "endpoint": "https://onidp9ejqf.execute-api.ap-northeast-1.amazonaws.com/staging",
            "region": "ap-northeast-1"
        },
        {
            "name": "organization",
            "endpoint": "https://que0dqsvhk.execute-api.ap-northeast-1.amazonaws.com/staging",
            "region": "ap-northeast-1"
        },
        {
            "name": "private",
            "endpoint": "https://8ju3zp3gtl.execute-api.ap-northeast-1.amazonaws.com/staging",
            "region": "ap-northeast-1"
        },
        {
            "name": "project",
            "endpoint": "https://8fte81dvo7.execute-api.ap-northeast-1.amazonaws.com/staging",
            "region": "ap-northeast-1"
        },
        {
            "name": "public",
            "endpoint": "https://t7nbg53n45.execute-api.ap-northeast-1.amazonaws.com/staging",
            "region": "ap-northeast-1"
        },
        {
            "name": "service",
            "endpoint": "https://jtbqnkqwif.execute-api.ap-northeast-1.amazonaws.com/staging",
            "region": "ap-northeast-1"
        },
        {
            "name": "syncData",
            "endpoint": "https://87z98uvj9f.execute-api.ap-northeast-1.amazonaws.com/staging",
            "region": "ap-northeast-1"
        },
        {
            "name": "task",
            "endpoint": "https://mvlxerzk97.execute-api.ap-northeast-1.amazonaws.com/staging",
            "region": "ap-northeast-1"
        },
        {
            "name": "user",
            "endpoint": "https://ts07jy74lj.execute-api.ap-northeast-1.amazonaws.com/staging",
            "region": "ap-northeast-1"
        },
        {
            "name": "verify",
            "endpoint": "https://rvwcstoo1a.execute-api.ap-northeast-1.amazonaws.com/staging",
            "region": "ap-northeast-1"
        },
        {
            "name": "auth",
            "endpoint": "https://6atbo3m9be.execute-api.ap-northeast-1.amazonaws.com/staging",
            "region": "ap-northeast-1"
        },
        {
            "name": "oauth2",
            "endpoint": "https://g5xhvim280.execute-api.ap-northeast-1.amazonaws.com/staging",
            "region": "ap-northeast-1"
        }
    ],
    "aws_cognito_identity_pool_id": "ap-northeast-1:fcce5891-5841-4373-87d7-d5f0ddf69db3",
    "aws_cognito_region": "ap-northeast-1",
    "aws_user_pools_id": "ap-northeast-1_6RLEjHMHi",
    "aws_user_pools_web_client_id": "ke60sjpuo295i99e9j2n594q0",
    "oauth": {
        "domain": "ap-northeast-16rlejhmhi.auth.ap-northeast-1.amazoncognito.com"
    },
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "stg-summit-hshc-koji-staging",
    "aws_content_delivery_bucket_region": "ap-northeast-1",
    "aws_content_delivery_url": "https://d2z1cwu2yq2nct.cloudfront.net",
    "aws_user_files_s3_bucket": "summit-hshc-bucket-stg",
    "aws_user_files_s3_bucket_region": "ap-northeast-1"
};


export default awsmobile;
